import {
  REGISTER_COLLEAGUE_REQUEST,
  REGISTER_COLLEAGUE_SUCCESS,
  REGISTER_COLLEAGUE_ERROR,
} from '../actions/constants'

const initialState = {
  registerSuccess: false,
  registerError: false,
  regErrorCode: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_COLLEAGUE_REQUEST:
      return { ...state, isLoading: true }
    case REGISTER_COLLEAGUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        registerSuccess: true,
        registerError: false,
        ...action.response,
      }
    case REGISTER_COLLEAGUE_ERROR:
      return {
        ...state,
        ...action.response,
        registerError: true,
        regErrorDescription: action.response.errorDescription,
      }
    default:
      return state
  }
}
